import $ from "jquery";
import { debounce } from "../utils/functions";

const $window = $(window);
const $carrouselEl = $(".carrousel");
$carrouselEl.addClass("carrousel--loading");

const loadDelay = 500;
const animationDuration = 300;
const swipeTreshold = { x: 30, y: 30 };

window.addEventListener("load", () => {
  $carrouselEl.each(function () {
    carrousel($(this));
  });
});

const carrousel = (carrouselEl) => {
  const $prev = carrouselEl.find(".carrousel__arrow_prev");
  const $next = carrouselEl.find(".carrousel__arrow_next");
  const $indicatorDots = carrouselEl.find(".carrousel__indicator-dot");

  const data = {
    item: 0,
    itemWidth: -1,
    allItemsWidth: -1,
    offsetLeft: -1,
    offsetRight: -1,
    startMousePos: { x: -1, y: -1 },
    endMousePos: { x: -1, y: -1 },
    animationLock: false,
    elementWidth: 0,
  };

  setTimeout(() => init(carrouselEl, data), loadDelay);
  $window.on(
    "resize:width",
    debounce(() => carrouselEl.addClass("carrousel--loading"), true, loadDelay)
  );
  $window.on(
    "resize:width",
    debounce(() => init(carrouselEl, data), false, loadDelay)
  );

  $prev.on("click", () => {
    !data.animationLock && scrollLeft(carrouselEl, data);
  });
  $next.on("click", () => {
    !data.animationLock && scrollRight(carrouselEl, data);
  });

  $indicatorDots.on("click", function () {
    if (!data.animationLock) {
      data.item = $(this).data("item");
      scrollToItem(
        carrouselEl,
        data,
        animationDuration,
        true,
        data.item * data.itemWidth,
        false
      );
    }
  });

  carrouselEl.on("touchstart", (event) => {
    onTouchStart(carrouselEl, event, data);
  });
  carrouselEl.on("touchend", (event) => {
    !data.animationLock && onTouchEnd(carrouselEl, event, data);
  });
};

const init = (element, data) => {
  const $card = element.find(".carrousel__card");
  data.itemWidth = $card.outerWidth(true);
  data.elementWidth = element.outerWidth();

  let padding = "";

  if (data.elementWidth < 1.2 * data.itemWidth) {
    let spareSpace;
    $card.css("margin-left") === $card.css("margin-right")
      ? (spareSpace = data.elementWidth - data.itemWidth)
      : (spareSpace = data.elementWidth - $card.outerWidth());
    padding = (spareSpace > 0 ? spareSpace / 2 : 0) + "px";
  }

  const $cardContainer = element.find(".carrousel__card-container");
  $cardContainer.css({
    "padding-left": padding,
    "padding-right": padding,
  });

  getOffsets(element, data);
  scrollToItem(element, data, 0, false);

  element.removeClass("carrousel--loading");
};

const indicator = (element, data) => {
  element.find(".carrousel__indicator-dot.active").removeClass("active");
  element
    .find(`.carrousel__indicator-dot[data-item="${data.item}"]`)
    .addClass("active");
};

const getOffsets = (element, data) => {
  const $cardContainer = element.find(".carrousel__card-container");
  data.offsetLeft = $cardContainer.position().left;
  data.offsetRight =
    data.elementWidth - data.offsetLeft - $cardContainer.outerWidth();
  const padding = {
    left: parseFloat($cardContainer.css("padding-left")),
    right: parseFloat($cardContainer.css("padding-right")),
  };
  data.allItemsWidth = $cardContainer.outerWidth() - padding.left;
};

const noOverflow = (data) =>
  (Math.floor(data.offsetRight) > 0 && Math.floor(data.offsetLeft) > 0) ||
  data.allItemsWidth < data.elementWidth;

const isScrolledLeft = (data) => Math.floor(Math.abs(data.offsetLeft)) == 0;
const isScrolledRight = (data) => Math.floor(Math.abs(data.offsetRight)) == 0;

const scrollLeft = (element, data) => {
  if (!isScrolledLeft(data)) {
    data.item--;
    scrollToItem(element, data, animationDuration, false);
  }
};

const scrollRight = (element, data) => {
  if (!isScrolledRight(data)) {
    data.item++;
    scrollToItem(element, data);
  }
};

const scrollToItem = (
  element,
  data,
  duration = animationDuration,
  endstep = true,
  position = data.item * data.itemWidth,
  constantSpeed = true
) => {
  data.animationLock = true;
  const $carrouselContainer = element.find(".carrousel__container");

  let speedMul = 1;
  if (constantSpeed === true) {
    const distance = Math.abs($carrouselContainer.scrollLeft() - position);
    distance != data.itemWidth && (speedMul = distance / data.itemWidth);
  }

  $carrouselContainer
    .stop()
    .animate({ scrollLeft: position }, duration * speedMul, "linear", () => {
      getOffsets(element, data);
      endstep === true
        ? Math.abs(data.offsetRight) <= data.itemWidth / 2 &&
          !isScrolledRight(data)
          ? scrollToItem(
              element,
              data,
              duration,
              false,
              position + Math.abs(data.offsetRight)
            )
          : (data.animationLock = false)
        : (data.animationLock = false);

      if (noOverflow(data)) {
        element.addClass("carrousel-no-overflow");
      } else {
        element.removeClass("carrousel-no-overflow");

        isScrolledLeft(data)
          ? element.addClass("carrousel-is-left")
          : element.removeClass("carrousel-is-left");

        isScrolledRight(data)
          ? element.addClass("carrousel-is-right")
          : element.removeClass("carrousel-is-right");
      }

      indicator(element, data);
    });
};

const onTouchStart = (element, event, data) => {
  if (element.hasClass("carrousel-no-overflow")) return;

  const evt =
    typeof event.originalEvent === undefined ? event : event.originalEvent;
  const touch = evt.touches[0] || evt.changedTouches[0];
  data.startMousePos.x = touch.pageX;
  data.startMousePos.y = touch.pageY;
};

const onTouchEnd = (element, event, data) => {
  if (element.hasClass("carrousel-no-overflow")) return;

  const evt =
    typeof event.originalEvent === undefined ? event : event.originalEvent;
  const touch = evt.touches[0] || evt.changedTouches[0];
  data.endMousePos.x = touch.pageX;
  data.endMousePos.y = touch.pageY;

  const mousePosDiff = {
    x: data.startMousePos.x - data.endMousePos.x,
    y: data.startMousePos.y - data.endMousePos.y,
  };

  data.startMousePos = { x: -1, y: -1 };
  data.endMousePos = { x: -1, y: -1 };

  Math.abs(mousePosDiff.x) > swipeTreshold.x &&
    (mousePosDiff.x > 0
      ? scrollRight(element, data)
      : scrollLeft(element, data));
};
